export default "assets/images/icons/arrow-cbc1e55b.svg";